var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-4" },
          [
            _c(
              "md-field",
              { attrs: { id: "inputField" } },
              [
                _c("md-input", {
                  attrs: { placeholder: "New " + _vm.columnTitle },
                  on: {
                    input: function($event) {
                      _vm.textNewValue = _vm.sanitizeInput($event)
                    }
                  },
                  model: {
                    value: _vm.textNewValue,
                    callback: function($$v) {
                      _vm.textNewValue = $$v
                    },
                    expression: "textNewValue"
                  }
                })
              ],
              1
            ),
            _c("br")
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-8" }, [
          _c(
            "div",
            { staticClass: "button-section button-section-style" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-raised md-accent md-white-color capitalize",
                  on: {
                    click: function($event) {
                      return _vm.addNewValue()
                    }
                  }
                },
                [_vm._v("Add New " + _vm._s(_vm.columnTitle))]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "md-table",
        { staticClass: "member-table" },
        [
          _c(
            "md-table-row",
            [
              _c("md-table-head", { staticClass: "card-header" }, [
                _vm._v(_vm._s(_vm.columnTitle) + "s\n\t\t\t\t"),
                _vm.sortOrder == -1
                  ? _c("img", {
                      attrs: {
                        src:
                          "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                      },
                      on: {
                        click: function($event) {
                          return _vm.sortColumn()
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.sortOrder == 1
                  ? _c("img", {
                      attrs: {
                        src:
                          "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                      },
                      on: {
                        click: function($event) {
                          return _vm.sortColumn()
                        }
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("md-table-head", { staticClass: "card-header" }, [
                _vm._v(" Actions ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.customValues, function(val, idx) {
            return _c("configuration-edit-row", {
              key: "values-" + idx,
              staticClass: "md-table-row",
              attrs: {
                title: _vm.columnTitle,
                index: idx,
                label: val,
                inputType: _vm.inputType
              },
              on: { update: _vm.update, remove: _vm.remove }
            })
          }),
          _vm._v(" "),
          _vm.customValues.length == 0
            ? [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: "3", align: "center" } },
                    [
                      _c("md-empty-state", {
                        staticClass: "table-no-record",
                        attrs: {
                          "md-label": "No Record Found",
                          "md-description": ""
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24950e83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24950e83","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigurationEditor.vue
// module id = null
// module chunks = 